export default "__VITE_ASSET__1b7d147b__"